import type { ReactNode } from "react"

export function Field({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex flex-col gap-x-2 gap-y-0.5 text-sm sm:flex-row">
      <span className="shrink-0 text-muted-foreground sm:w-44">{label}</span>
      <span className="min-w-0 break-words">{value}</span>
    </div>
  )
}
